import { RegExp } from 'core-js';
import Vue from 'vue';

export default Vue.directive('mask', {
    bind: function (el, { expression }) {
        const input = el.children[1]
        const regex = new RegExp(expression.replace(/'/g, ''))
        input.addEventListener('input', () => {
            if (!regex.test(input.value)) {
                el.classList.remove('valid')
                el.classList.add('not-valid')
            } else {
                el.classList.remove('not-valid')
                el.classList.add('valid')
                el.nextSibling.innerText = ''
            }
        })
    }
})